// Redesign 2026 – filtr otázek podle tématu (Otázky a odpovědi).
//
// Bez JS jsou vidět všechny otázky a tlačítka filtru zůstanou schovaná (`hidden`) – stránka
// funguje dál, filtr je jen zrychlení. Rozbalování otázek je nativní <details>, JS na něj nesahá.
//
// Markup: [data-rd-faq-filter] s tlačítky [data-rd-faq-topic="<kotva>"] (prázdná hodnota = vše),
// otázky [data-rd-faq-item="<kotva>"] uvnitř [data-rd-faq-list] v sekci #otazky.
// Kotva tématu v adrese (#nakup) nebo odkaz na ni (tlačítka v hlavičce) téma vybere a sjede
// na otázky. Kotva otázky (#otazka-…) otázku rozbalí.

const ACTIVE = 'is-active';

export default function initRedesignOtazky() {
  const group = document.querySelector('[data-rd-faq-filter]');
  const list = document.querySelector('[data-rd-faq-list]');
  if (!list) {
    return;
  }

  const section = list.closest('section') || list;
  const items = [...list.querySelectorAll('[data-rd-faq-item]')];

  // odkaz na konkrétní otázku ji rovnou rozbalí (prohlížeče to u <details> samy nedělají všude)
  const openFromHash = () => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    const target = id ? document.getElementById(id) : null;
    if (target && target.tagName === 'DETAILS' && list.contains(target)) {
      target.open = true;
    }
  };
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  if (!group) {
    return;
  }

  const buttons = [...group.querySelectorAll('[data-rd-faq-topic]')];
  const topics = buttons.map((button) => button.dataset.rdFaqTopic).filter(Boolean);

  const apply = (topic) => {
    items.forEach((item) => {
      item.hidden = topic !== '' && item.dataset.rdFaqItem !== topic;
    });

    buttons.forEach((button) => {
      const isActive = button.dataset.rdFaqTopic === topic;
      button.classList.toggle(ACTIVE, isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  // téma do adresy, ať jde filtrovaný výpis poslat odkazem; „Vše“ kotvu smaže
  const remember = (topic) => {
    if (window.history && window.history.replaceState) {
      const url = window.location.pathname + window.location.search + (topic ? `#${topic}` : '');
      window.history.replaceState(null, '', url);
    }
  };

  const pick = (topic, scroll) => {
    apply(topic);
    remember(topic);
    if (scroll) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  group.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rd-faq-topic]');
    if (button) {
      pick(button.dataset.rdFaqTopic, false);
    }
  });

  // odkazy s kotvou tématu kdekoli na stránce (tlačítka v hlavičce)
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    const topic = link ? link.getAttribute('href').slice(1) : '';
    if (topic && topics.includes(topic)) {
      event.preventDefault();
      pick(topic, true);
    }
  });

  group.hidden = false;

  const initial = window.location.hash.slice(1);
  if (topics.includes(initial)) {
    apply(initial);
    section.scrollIntoView({ block: 'start' });
  }
}
